/**
 * @file テンプレート
 */

'use strict';
import Common from '../Utils/Common';

let instance = null;

/**
 * @class Template
 * @classdesc テンプレート
 */
export default class Template {

	/**
	 * @constructor
	 */
	constructor() {
		if (instance) {
			return instance;
		}

		instance = this;
		return instance;
	};


	/**
	 * @memberof Template
	 * @return {string}
	 */
	static Operator(idx) {
		console.log(`Template.Operator`);
		const no = parseInt(idx) + 1;
		return `
<li class="list-item list-item-additional list-item-operator" data-no="${no}">
	<a class="btn btn-add btn-success" data-add-type="operator" data-base-object=".list-item"><i class="fas fa-plus"></i></a>
	<a class="btn btn-delete btn-danger" data-base-object=".list-item"><i class="fas fa-minus"></i></a>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">操作担当者<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-3">
			<div class="input-select select2-wrap">
				<select class="validate select2 input-select-select member_id" name="member_id[${idx}]" data-validate="empty">
				</select>
			</div>
		</div>
	</div>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">権限<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-4">
			<div class="input-select">
				<select class="validate input-select-select" name="operator_role[${idx}]" data-validate="empty">
					<option value="1">編集者（メールマガジン送付可）</option>
					<option value="2">閲覧者（メールマガジン送付可）</option>
					<option value="3">閲覧者（メールマガジン送付不可）</option>
					<option value="4">メールマガジン送付担当者</option>
				</select>
			</div>
		</div>
	</div>
</li>`;
	};


	/**
	 * @memberof Template
	 * @return {string}
	 */
	static PaidMutualAid(idx) {
		console.log(`Template.PaidMutualAid`);
		const no = parseInt(idx) + 1;
		return `
<li class="list-item list-item-additional">
	<a class="btn btn-add btn-success" data-add-type="paid-mutual-aid" data-base-object=".list-item">
		<i class="fas fa-plus"></i>
	</a>
	<a class="btn btn-delete btn-danger" data-base-object=".list-item">
		<i class="fas fa-minus"></i>
	</a>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">支払<span class="mutual-aid-payment-count">${no}</span>回目</div>
		<div class="col-md-8"></div>
	</div>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">共済金支払日<span class="badge badge-success float-right ml-1">任意</span></div>
		<div class="col-md-8">
			<div class="input-group">
				<input class="w150 validate input-text" name="accident_payment_paid_date[${idx}]" value="" type="text" data-validate="datepicker" data-datepicker="true" data-clear="true">
				<div class="input-group-append">
					<div class="input-group-text"><i class="fas fa-calendar"></i></div>
				</div>
			</div>
			<div class="error-tip">
				<div class="error-tip-inner"></div>
			</div>
		</div>
	</div>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">支払金額<span class="badge badge-success float-right ml-1">任意</span></div>
		<div class="col-md-3"><input class="zen2han validate paid_mutual_aid_price input-text" name="accident_payment_amount[${idx}]" data-validate="number" value="" type="text"><div class="error-tip"><div class="error-tip-inner"></div></div></div>
	</div>
</li>`;
	}


	/**
	 * @memberof Template
	 * @return {string}
	 */
	static AdministrationalOperator(idx, responseName) {
		console.log(`Template.AdministrationalOperator`);
		return `
<li class="list-item list-item-additional">
	<a class="btn btn-add btn-success" data-add-type="administrational-operator" data-base-object=".list-item">
		<i class="fas fa-plus"></i>
	</a>
	<a class="btn btn-delete btn-danger" data-base-object=".list-item">
		<i class="fas fa-minus"></i>
	</a>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">加盟員検索</div>
		<div class="col-md-8"><button class="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#modal-common-member-search" data-index="${idx}">検索モーダルを開く</button></div>
	</div>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">操作担当者<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-8">
			<div class="row">
				<div class="col-md-6">
					<input class="selected-member-id" type="hidden" name="member_id[${idx}]" data-response-name="member_id" data-index="${idx}">
					<input class="static-input-text validate selected-member-id-dummy border-0 pointer-events-none input-text" data-validate="empty" data-response-name="${responseName}" data-index="${idx}" placeholder="検索モーダルから選択してください" type="text" tabindex="-1">
				</div>
				<div class="col-md-6 d-flex align-items-center">
					<div class="error-tip">
						<div class="error-tip-inner"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">権限<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-8 flex align-items-center">
			<div class="input-checkbtn mt0 mb0"><input class="validate operator_${idx + 1}_role input-checkbtn-input" id="operator_${idx + 1}_role_1" name="operator_role[${idx}][]" value="1" data-validate="checkboxempty" type="checkbox" checked><label class="input-checkbtn-label" for="operator_${idx + 1}_role_1">共済業務</label></div>
			<div class="input-checkbtn mt0 mb0 ml15"><input class="validate operator_${idx + 1}_role input-checkbtn-input" id="operator_${idx + 1}_role_2" name="operator_role[${idx}][]" value="2" data-validate="checkboxempty" type="checkbox" checked><label class="input-checkbtn-label" for="operator_${idx + 1}_role_2">維持会員業務</label></div>
			<div class="input-checkbtn mt0 mb0 ml15"><input class="validate operator_${idx + 1}_role input-checkbtn-input" id="operator_${idx + 1}_role_3" name="operator_role[${idx}][]" value="3" data-validate="checkboxempty" type="checkbox" checked><label class="input-checkbtn-label" for="operator_${idx + 1}_role_3">加盟登録承認業務</label></div>
			<div class="input-checkbtn mt0 mb0 ml15"><input class="validate operator_${idx + 1}_role input-checkbtn-input" id="operator_${idx + 1}_role_4" name="operator_role[${idx}][]" value="4" data-validate="checkboxempty" type="checkbox" checked><label class="input-checkbtn-label" for="operator_${idx + 1}_role_4">権限切り替え</label></div>
		</div>
		<div class="offset-md-3 col-md-8">
			<div class="error-tip">
				<div class="error-tip-inner"></div>
			</div>
		</div>
	</div>
</li>`;
	};


	/**
	 * @memberof Template
	 * @return {string}
	 */
	static GeneralOperator(idx, responseName) {
		console.log(`Template.GeneralOperator`);
		return `
<li class="list-item list-item-additional">
	<a class="btn btn-add btn-success" data-add-type="general-operator" data-base-object=".list-item">
		<i class="fas fa-plus"></i>
	</a>
	<a class="btn btn-delete btn-danger" data-base-object=".list-item">
		<i class="fas fa-minus"></i>
	</a>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">加盟員検索</div>
		<div class="col-md-8"><button class="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#modal-common-member-search" data-index="${idx}">検索モーダルを開く</button></div>
	</div>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">操作担当者<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-8">
			<div class="row">
				<div class="col-md-6">
					<input class="selected-member-id" type="hidden" name="member_id[${idx}]" data-response-name="member_id" data-index="${idx}">
					<input class="static-input-text validate selected-member-id-dummy border-0 pointer-events-none input-text" data-validate="empty" data-response-name="${responseName}" data-index="${idx}" placeholder="検索モーダルから選択してください" type="text" tabindex="-1">
				</div>
				<div class="col-md-6 d-flex align-items-center">
					<div class="error-tip">
						<div class="error-tip-inner"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">権限<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-4">
			<div class="input-select">
				<select class="validate input-select-select" name="operator_role[${idx}]" data-validate="empty">
					<option value="1" selected>編集者（メールマガジン送付可）</option>
					<option value="2">閲覧者（メールマガジン送付可）</option>
					<option value="3">閲覧者（メールマガジン送付不可）</option>
					<option value="4">メールマガジン送信担当</option>
				</select>
				<div class="error-tip">
					<div class="error-tip-inner"></div>
				</div>
			</div>
		</div>
	</div>
</li>`;
	};


	/**
	 * @memberof Template
	 * @return {string}
	 */
	static Supporter(idx) {
		console.log(`Template.Supporter`);
		return `
<li class="list-item list-item-additional">
	<a class="btn btn-add btn-success" data-add-type="supporter" data-base-object=".list-item">
		<i class="fas fa-plus"></i>
	</a>
	<a class="btn btn-delete btn-danger" data-base-object=".list-item">
		<i class="fas fa-minus"></i>
	</a>
	<div class="row align-items-center form-group">
		<div class="col-md-3 col-form-label">対象<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-8 change-display-group" data-default-show-target=".input_type_target">
			<div class="input-radio mb0 mt0"><input class="input-radio-input supporter-registered-at" id="input_type_${idx}_1" name="input_type_[${idx}]" value="1" data-show-target="#input_type_${idx}_1_target" checked="" type="radio"><label class="input-radio-label" for="input_type_${idx}_1">スカウトを登録する（隊にも登録）</label></div>
			<div class="input-radio mb0 mt0"><input class="input-radio-input supporter-registered-at" id="input_type_${idx}_2" name="input_type_[${idx}]" value="2" data-show-target="#input_type_${idx}_2_target" type="radio"><label class="input-radio-label" for="input_type_${idx}_2">隊に登録する</label></div>
		</div>
	</div>
	<div id="input_type_${idx}_1_target" style="">
		<div class="row form-group">
			<div class="col-md-3 col-form-label">スカウト<span class="badge badge-danger float-right ml-1">必須</span></div>
			<div class="col-md-3">
				<div class="input-select select2-wrap">
					<select class="validate select2 select-member input-select-select scout_member_ids" name="scout_member_ids[${idx}]" data-validate="empty">
					</select>
				</div>
			</div>
			<div class="offset-md-3 col-md-9">
				<p class="text text-caution">スカウトを登録する場合、スカウトの所属する隊にも登録されます。</p>
			</div>
			<div class="offset-md-3 col-md-9">
				<div class="error-tip">
					<div class="error-tip-inner"></div>
				</div>
			</div>
		</div>
	</div>
	<div id="input_type_${idx}_2_target" style="display: none;">
		<div class="row form-group">
			<div class="col-md-3 col-form-label">隊<span class="badge badge-danger float-right ml-1">必須</span></div>
			<div class="col-md-3">
				<div class="input-select select2-wrap">
					<select class="validate select2 select-member input-select-select master_den_ids" name="master_den_ids[${idx}]" data-validate="empty">
					</select>
				</div>
			</div>
			<div class="offset-md-3 col-md-9">
				<div class="error-tip">
					<div class="error-tip-inner"></div>
				</div>
			</div>
		</div>
	</div>
</li>`;
	};


	/**
	 * @memberof Template
	 * @return {string}
	 */
	static DivideContribution(idx) {
		console.log(`Template.DivideContribution`);
		return `
<li class="list-item list-item-additional">
	<a class="btn btn-add btn-success" data-add-type="divide-contribution" data-base-object=".list-item">
		<i class="fas fa-plus"></i>
	</a>
	<a class="btn btn-delete btn-danger" data-base-object=".list-item">
		<i class="fas fa-minus"></i>
	</a>
	<div class="row mt15 form-group">
		<div class="col-md-3 col-form-label">支援先<span class="renumbering">1</span>種別<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-3">
			<div class="input-select"><select class="validate contribution_type input-select-select" name="contribution_payment_types[]" data-validate="empty">
					<option value="" data-contribution-type="unselected">▼選択</option>
					<option value="1" data-contribution-type="contributor-membership-fee">維持会費</option>
					<option value="2" data-contribution-type="general-contribution">一般寄附</option>
					<option value="3" data-contribution-type="specified-purpose-contribution">目的別指定寄附</option>
				</select></div>
		</div>
		<div class="offset-md-3 col-md-8">
			<div class="error-tip">
				<div class="error-tip-inner"></div>
			</div>
		</div>
	</div>
	<div class="row contributor-membership-fee-wrap form-group">
		<div class="col-md-3 col-form-label">支援先連盟<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-3">
			<div class="input-select">
				<select class="validate council_id ignore-to-remove-name-attribute input-select-select" name="master_council_ids[]" data-validate="empty">
					<option value="">▼選択</option>
					<option value="1">北海道</option>
					<option value="2">青森県</option>
					<option value="3">岩手</option>
					<option value="4">宮城県</option>
					<option value="5">秋田県</option>
					<option value="6">山形県</option>
					<option value="7">福島</option>
					<option value="8">茨城県</option>
					<option value="9">栃木県</option>
					<option value="10">群馬県</option>
					<option value="11">埼玉県</option>
					<option value="12">千葉県</option>
					<option value="13">東京</option>
					<option value="14">神奈川</option>
					<option value="15">新潟</option>
					<option value="16">富山県</option>
					<option value="17">石川県</option>
					<option value="18">福井</option>
					<option value="19">山梨</option>
					<option value="20">長野県</option>
					<option value="21">岐阜県</option>
					<option value="22">静岡県</option>
					<option value="23">愛知</option>
					<option value="24">三重</option>
					<option value="25">滋賀</option>
					<option value="26">京都</option>
					<option value="27">大阪</option>
					<option value="28">兵庫</option>
					<option value="29">奈良県</option>
					<option value="30">和歌山</option>
					<option value="31">鳥取</option>
					<option value="32">島根</option>
					<option value="33">岡山</option>
					<option value="34">広島県</option>
					<option value="35">山口県</option>
					<option value="36">徳島</option>
					<option value="37">香川</option>
					<option value="38">愛媛県</option>
					<option value="39">高知県</option>
					<option value="40">福岡県</option>
					<option value="41">佐賀県</option>
					<option value="42">長崎県</option>
					<option value="43">熊本県</option>
					<option value="44">大分県</option>
					<option value="45">宮崎</option>
					<option value="46">鹿児島県</option>
					<option value="47">沖縄県</option>
					<option value="48">日本</option>
				</select>
			</div>
		</div>
		<div class="offset-md-3 col-md-8">
			<div class="error-tip">
				<div class="error-tip-inner"></div>
			</div>
		</div>
	</div>
	<div class="row specified-purpose-contribution form-group"">
		<div class="col-md-3 col-form-label">目的別指定寄附<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-3">
			<div class="input-select">
				<select class="validate specified_purpose_id ignore-to-remove-name-attribute input-select-select ignore-validate" name="purpose_donation_credit_small_account_codes[]" data-validate="empty">
				</select>
			</div>
		</div>
		<div class="offset-md-3 col-md-8">
			<div class="error-tip">
				<div class="error-tip-inner"></div>
			</div>
		</div>
	</div>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">金額<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-3"><input class="zen2han validate contribution_price input-text" name="prices[]" data-validate="empty number nosymbol nospace minnum-1" value="" type="text"></div>
		<div class="offset-md-3 col-md-8">
			<div class="error-tip">
				<div class="error-tip-inner"></div>
			</div>
		</div>
	</div>
</li>`
	};


	/**
	 * @memberof Template
	 * @return {string}
	 */
	static DivideContribution2(idx) {
		console.log(`Template.DivideContribution2`);
		return `
<li class="list-item list-item-additional">
	<a class="btn btn-add btn-success" data-add-type="divide-contribution2" data-base-object=".list-item">
		<i class="fas fa-plus"></i>
	</a>
	<a class="btn btn-delete btn-danger" data-base-object=".list-item">
		<i class="fas fa-minus"></i>
	</a>
	<div class="row mt15 form-group">
		<div class="col-md-3 col-form-label">支援先<span class="renumbering">1</span>種別<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-5">
			<div class="input-select"><select class="validate contribution_type input-select-select" name="contribution_payment_types[]" data-validate="empty">
					<option value="" data-contribution-type="unselected">▼選択</option>
					<option value="1" data-contribution-type="contributor-membership-fee">維持会費</option>
					<option value="2" data-contribution-type="general-contribution">一般寄附</option>
					<option value="3" data-contribution-type="specified-purpose-contribution">目的別指定寄附</option>
				</select></div>
		</div>
		<div class="offset-md-3 col-md-8">
			<div class="error-tip">
				<div class="error-tip-inner"></div>
			</div>
		</div>
	</div>
	<div class="row contributor-membership-fee-wrap form-group">
		<div class="col-md-3 col-form-label">支援先連盟<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-5">
			<div class="input-select">
				<select class="validate council_id ignore-to-remove-name-attribute input-select-select" name="master_council_ids[]" data-validate="empty">
					<option value="">▼選択</option>
					<option value="1">北海道</option>
					<option value="2">青森県</option>
					<option value="3">岩手</option>
					<option value="4">宮城県</option>
					<option value="5">秋田県</option>
					<option value="6">山形県</option>
					<option value="7">福島</option>
					<option value="8">茨城県</option>
					<option value="9">栃木県</option>
					<option value="10">群馬県</option>
					<option value="11">埼玉県</option>
					<option value="12">千葉県</option>
					<option value="13">東京</option>
					<option value="14">神奈川</option>
					<option value="15">新潟</option>
					<option value="16">富山県</option>
					<option value="17">石川県</option>
					<option value="18">福井</option>
					<option value="19">山梨</option>
					<option value="20">長野県</option>
					<option value="21">岐阜県</option>
					<option value="22">静岡県</option>
					<option value="23">愛知</option>
					<option value="24">三重</option>
					<option value="25">滋賀</option>
					<option value="26">京都</option>
					<option value="27">大阪</option>
					<option value="28">兵庫</option>
					<option value="29">奈良県</option>
					<option value="30">和歌山</option>
					<option value="31">鳥取</option>
					<option value="32">島根</option>
					<option value="33">岡山</option>
					<option value="34">広島県</option>
					<option value="35">山口県</option>
					<option value="36">徳島</option>
					<option value="37">香川</option>
					<option value="38">愛媛県</option>
					<option value="39">高知県</option>
					<option value="40">福岡県</option>
					<option value="41">佐賀県</option>
					<option value="42">長崎県</option>
					<option value="43">熊本県</option>
					<option value="44">大分県</option>
					<option value="45">宮崎</option>
					<option value="46">鹿児島県</option>
					<option value="47">沖縄県</option>
					<option value="48">日本</option>
				</select>
			</div>
		</div>
		<div class="offset-md-3 col-md-8">
			<div class="error-tip">
				<div class="error-tip-inner"></div>
			</div>
		</div>
	</div>
	<div class="row specified-purpose-contribution form-group"">
		<div class="col-md-3 col-form-label">目的別指定寄附<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-5">
			<div class="input-select">
				<select class="validate specified_purpose_id ignore-to-remove-name-attribute input-select-select ignore-validate" name="purpose_donation_credit_small_account_codes[]" data-validate="empty">
				</select>
			</div>
		</div>
		<div class="offset-md-3 col-md-8">
			<div class="error-tip">
				<div class="error-tip-inner"></div>
			</div>
		</div>
	</div>
	<div class="row form-group">
		<div class="col-md-3 col-form-label">金額<span class="badge badge-danger float-right ml-1">必須</span></div>
		<div class="col-md-5"><input class="zen2han validate contribution_price input-text" name="prices[]" data-validate="empty number nosymbol nospace minnum-1" value="" type="text"></div>
		<div class="offset-md-3 col-md-8">
			<div class="error-tip">
				<div class="error-tip-inner"></div>
			</div>
		</div>
	</div>
</li>`
	};


	/**
	 * @memberof Template
	 * @return {string}
	 */
	static errorModal(errorText = '入力項目に誤りがあります。') {
		console.log(`Template.errorModal`)
		return `
<div class="modal modal-error fade show" id="modal-error" tabindex="-1" style="padding-right: 15px; display: block;" aria-modal="true" role="dialog">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header bg-danger text-white">
				<h5 class="modal-title">エラー</h5>
				<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="tac pt20 mb30">
					<i class="fas fa-exclamation-triangle text-danger" style="font-size: 60px;"></i>			
				</div>
				<div>${errorText}</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">閉じる</button>
			</div>
		</div>
	</div>
</div>`
	}


	/**
	 * @memberof Template
	 * @return {string}
	 */
	static completeModal(message = '処理が正常に終了しました。') {
		return `
<div class="modal modal-success fade show" id="modal-success" tabindex="-1" style="padding-right: 15px; display: block;" aria-modal="true" role="dialog">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header bg-success text-white">
				<h5 class="modal-title">完了</h5>
				<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="tac pt20 mb30">
					<i class="fas fa-check text-success" style="font-size: 60px;"></i>			
				</div>
				<div>${message}</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">閉じる</button>
			</div>
		</div>
	</div>
</div>`
	}
}
